import { useParams } from "react-router-dom";

import { ConfigurationViewGuard } from "./parts/ConfigurationViewGuard";
import { UpdateTicketSimulatorNewConfigs } from "./parts/UpdateTicketSimulatorNewConfigs";
import { UpdateSimulatorGoodFeedbackSeperation } from "./parts/UpdateSimulatorGoodFeedbackSeperation";
import { useSimulatorConfiguration } from "./useSimulatorConfiguration";
import { UpdateSimulatorReclassifyTopicOnSubsequentAnswers } from "./parts/UpdateSimulatorReclassifyTopicOnSubsequentAnswers";

export function AdvancedConfiguration() {
  const { simulatorId } = useParams();
  const { simulator } = useSimulatorConfiguration(simulatorId);

  const channel = simulator?.channel;

  if (channel !== "autonomous_ticket_event") {
    return null;
  }

  return (
    <ConfigurationViewGuard view={"advanced"}>
      <UpdateTicketSimulatorNewConfigs />
      <UpdateSimulatorGoodFeedbackSeperation />
      <UpdateSimulatorReclassifyTopicOnSubsequentAnswers />
    </ConfigurationViewGuard>
  );
}
